import { fabric } from 'fabric';
import { FABRIC_CUSTOM_OBJECT } from '../../../utils';

export function createControlScrollBar(e) {
  const { target } = e;
  const {
    top,
    left,
    width,
    height,
    postionTriangle,
    postionRect,
    widthPercent,
    heithPercent,
    rectStyle,
    triangleStyle,
  } = target;
  const { canvas } = window;
  const pointer = window.canvas.getPointer(e);
  const topRect = top + (postionRect * height) / 100;
  const controlRect = (Math.abs(pointer.y - topRect) * 100) / height <= heithPercent / 2;
  if (controlRect) {
    const myOptions = JSON.parse(JSON.stringify(rectStyle));
    const rect = new fabric.Rect({
      ...myOptions,
      name: FABRIC_CUSTOM_OBJECT.rectScrollBar,
      originX: 'center',
      originY: 'center',
      lockMovementX: true,
      hasControls: false,
      isNotObj: true,
      parentObj: target,
      borderColor: 'blue',
      borderScaleFactor: 2,
      top: topRect,
      left: left + width / 2,
      width: (widthPercent * width) / 100,
      height: (heithPercent * height) / 100,
    });

    target.rectStyle = { ...target.rectStyle, fill: 'transparent', stroke: 'transparent' };
    canvas.remove(target);
    canvas.add(target);

    canvas.add(rect);
    canvas.setActiveObject(rect);
  } else {
    const myOptions = JSON.parse(JSON.stringify(target.triangleStyle));
    const triangle1 = new fabric.Triangle({
      ...myOptions,
      name: FABRIC_CUSTOM_OBJECT.triangleScrollBar,
      originX: 'center',
      originY: 'center',
      lockMovementX: true,
      hasControls: false,
      isNotObj: true,
      parentObj: target,
      borderColor: 'blue',
      borderScaleFactor: 2,
      top: top + (postionTriangle * height) / 100,
      left: left + width / 2,
    });

    const triangle2 = new fabric.Triangle({
      ...myOptions,
      fill: String(target.triangleStyle.fill),
      stroke: String(target.triangleStyle.stroke),
      angle: triangleStyle.angle + 180,
      name: FABRIC_CUSTOM_OBJECT.triangleScrollBar,
      originX: 'center',
      originY: 'center',
      lockMovementX: true,
      hasControls: false,
      isNotObj: true,
      parentObj: target,
      borderColor: 'blue',
      borderScaleFactor: 2,
      top: top + height - (postionTriangle * height) / 100,
      left: left + width / 2,
    });

    triangle1.set({ botTriangle: triangle2 });

    target.triangleStyle = { ...target.triangleStyle, fill: 'transparent', stroke: 'transparent' };
    canvas.remove(target);
    canvas.add(target);

    canvas.add(triangle1);
    canvas.add(triangle2);
    canvas.setActiveObject(triangle1);
  }

  return true;
}
function calculatorPercentage(circle, obj) {
  return ((circle.left - obj.left - obj.strokeWidth / 2) * 100) / obj.width;
}
export function controlScrollBarMoving(e) {
  const { target } = e;
  const { parentObj } = target;
  const controlRect = e.target.name === FABRIC_CUSTOM_OBJECT.rectScrollBar;

  if (controlRect) {
    const top = target.top - target.height / 2;
    const bot = target.top + target.height / 2;
    if (top < parentObj.top) target.set({ top: target.top + Math.abs(top - parentObj.top) });
    if (bot > parentObj.top + parentObj.height) {
      target.set({
        top: target.top - Math.abs(bot - (parentObj.top + parentObj.height)),
      });
    }
    target.setCoords();
    parentObj.postionRect = ((target.top - parentObj.top) * 100) / parentObj.height;
  } else {
    const top = target.top - target.height / 2;
    const bot = target.top + target.height / 2;
    if (top < parentObj.top) target.set({ top: target.top + Math.abs(top - parentObj.top) });
    if (bot > parentObj.top + parentObj.height / 4) {
      target.set({
        top: target.top - Math.abs(bot - (parentObj.top + parentObj.height / 4)),
      });
    }
    target.setCoords();

    const { botTriangle } = target;
    parentObj.postionTriangle = ((target.top - parentObj.top) * 100) / parentObj.height;
    botTriangle.set({ top: parentObj.top + parentObj.height - (parentObj.postionTriangle * parentObj.height) / 100 });
  }

  const myScrollBar = parentObj;
  const { radius } = target;

  const rx = parseInt(myScrollBar.rx);

  const epsRight = myScrollBar.strokeWidth / 2 + myScrollBar.height / 2 - rx;
  if (target.left > myScrollBar.left + myScrollBar.width - radius + epsRight) {
    target.set({ left: myScrollBar.left + myScrollBar.width - radius + epsRight });
    target.setCoords();
  }

  const epsLeft = myScrollBar.height / 2 - rx;
  if (target.left < myScrollBar.left + radius - epsLeft) {
    target.set({ left: myScrollBar.left + radius - epsLeft });
    target.setCoords();
  }
  myScrollBar.set({ percent: calculatorPercentage(target, myScrollBar) });
  myScrollBar.setCoords();
  return true;
}
export function controlScrollBarModified(e) {
  // botTriangle
  const target = e;
  const { botTriangle } = target;
  if (!botTriangle) return false;
  if (
    target.fill !== botTriangle.fill ||
    target.stroke !== botTriangle.stroke ||
    target.strokeWidth !== botTriangle.strokeWidth ||
    target.width !== botTriangle.width ||
    target.height !== botTriangle.height ||
    target.opacity !== botTriangle.opacity
  ) {
    const { fill, strokeWidth, stroke, width, height, opacity } = target;
    botTriangle.set({
      fill,
      strokeWidth,
      stroke,
      width,
      height,
      opacity,
    });
    botTriangle.setCoords();
    window.canvas.remove(botTriangle);
    window.canvas.add(botTriangle);
  }
  return true;
}
export function controlScrollBarRemove(target) {
  const { canvas } = window;
  const myScrollBar = target.parentObj;
  const controlRect = target.name === FABRIC_CUSTOM_OBJECT.rectScrollBar;

  if (controlRect) {
    const { fill, stroke, strokeWidth, rx, ry, opacity, name } = target;
    myScrollBar.set({
      rectStyle: {
        fill,
        stroke,
        strokeWidth,
        rx,
        ry,
        opacity,
        name,
      },
    });
  } else {
    const { fill, stroke, strokeWidth, rx, ry, opacity, name, angle, width, height } = target;
    myScrollBar.set({
      triangleStyle: {
        fill,
        stroke,
        strokeWidth,
        rx,
        ry,
        opacity,
        name,
        angle,
        width,
        height,
      },
    });
  }

  myScrollBar.setCoords();
  canvas.remove(target);
  if (target.botTriangle) canvas.remove(target.botTriangle);
  return true;
}
